import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "custom-button" }
const _hoisted_2 = ["type", "disabled"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "animate-spin -ml-1 mr-0 h-6 mx-auto text-center w-5 text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: _normalizeClass(["button", _ctx.status === 'primary' ? 'primary-button' : 'error-button']),
      type: _ctx.type,
      disabled: _ctx.loading ? true : _ctx.disabled
    }, [
      (!_ctx.loading)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.text), 1))
        : _createCommentVNode("", true),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("svg", _hoisted_4, [...(_cache[0] || (_cache[0] = [
            _createElementVNode("circle", {
              class: "opacity-25",
              cx: "12",
              cy: "12",
              r: "10",
              stroke: "currentColor",
              "stroke-width": "4"
            }, null, -1),
            _createElementVNode("path", {
              class: "opacity-75",
              fill: "currentColor",
              d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            }, null, -1)
          ]))]))
        : _createCommentVNode("", true)
    ], 10, _hoisted_2)
  ]))
}